/**
 * Copyright 2022 Design Barn Inc.
 */

import * as React from 'react';

export const CloseIcon: React.FC = (): JSX.Element => (
  <svg width="18" height="18" viewBox="0 0 18 18">
    <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z" />
  </svg>
);
